<template>
  <div class='serie-item flex flex-col xl:grid gap-2 xl:gap-6'>
    <template v-if="serie">
      <div class="serie-item-image">
        <div class="relative w-full aspect-[916/520] overflow-hidden rounded-8px">
          <a :href="serie.link" class="w-full h-full">
            <img
              v-lazy="serie.feature_banner_url"
              :alt="serie.title"
              @load="imageLoaded = true"
              :class="['w-full h-full object-cover', { 'opacity-0': !imageLoaded }]"
            />
          </a>
        </div>
      </div>
      <div class="serie-item-info flex flex-col xl:justify-center p-4 xl:py-0">
        <div v-if="serie.serie_tag_list?.length > 1" class="serie-item-tags mb-4">
          <div class="flex flex-wrap gap-2">
            <span v-for='tag in randomTags' :key="tag" class="inline-block px-2.5 leading-6 rounded-[24px] text-14px text-orange-200 bg-gray-500 capitalize">
              {{ tag }}
            </span>
          </div>
        </div>

        <div class="serie-item-title text-18px sm:text-20px font-medium leading-6 sm:leading-7">
          {{ serie.title }}
        </div>

        <div class="mt-2 flex xl:items-center justify-between flex-col xl:flex-row gap-6">
          <div class="serie-item-content text-16px text-gray-150 leading-6 break-all line-clamp-2 flex-1">
            {{ serie.content }}
          </div>

          <div class="serie-item-button xl:mt-0">
            <a :href="serie.link" class="inline-block text-14px md:text-16px text-gray-150 font-medium leading-5 md:leading-6 py-2 px-8 rounded-[24px] border-2 border-gray-150 hover:bg-gray-300">
              {{ $t('series.index.view_collection')}}
            </a>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <!-- Skeleton screen -->
      <div class="skeleton-card">
        <div class="skeleton-image h-40 bg-grey-300"></div>
        <div class="skeleton-data-container p-4">
          <div class="skeleton-title h-6 bg-grey-300 mb-2"></div>
          <div class="skeleton-metrics flex justify-between">
            <div class="skeleton-metric h-4 bg-grey-300 w-1/3"></div>
            <div class="skeleton-metric h-4 bg-grey-300 w-1/3"></div>
            <div class="skeleton-metric h-4 bg-grey-300 w-1/3"></div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import viewCountIcon from '../../images/icons/view-count.svg'
import likesIcon from '../../images/icons/likes.svg'
import downloadIcon from '../../images/icons/download.svg'

export default defineComponent({
  props: {
    serie: {
      type: Object,
      required: true
    },
    current_profile: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      imageLoaded: false,
      viewCountIcon,
      likesIcon,
      downloadIcon,
      randomTags: []
    }
  },
  created() {
    if (this.serie && this.serie.serie_tag_list) {
      this.randomTags = [...this.serie.serie_tag_list].sort(() => Math.random() - 0.5).slice(0, 3);
    }
  },
  methods: {
    formatViewsCount(count) {
      return new Intl.NumberFormat().format(count);
    }
  }
});
</script>